import { AxiosInstance } from 'axios';
import { parseActivities, parseActivitiesOrder } from './utils';
import {
  ActivitiesStatusEnum,
  ActivitiesData,
  PromiseActivitiesData,
} from './types';
import { handleErrorIntoService } from '@/tools/handleErrorIntoService';

export const getActivitiesData = (api: AxiosInstance) => ({
  getActivities: async (
    params: any,
    parseData: Function = parseActivities
  ): Promise<PromiseActivitiesData> => {
    const { data } = await api.get<ActivitiesData>(
      ActivitiesStatusEnum.GET_ACTIVITIES,
      {
        params,
      },
    );
    return { ...data, data: parseData(data.data) };
  },
});

export const getActivitiesOrderData = (api: AxiosInstance) => ({
  getActivitiesOrder: async (
    params: any,
    parseData: Function = parseActivitiesOrder
  ): Promise<PromiseActivitiesData> => {
    const { data } = await handleErrorIntoService(
      api.get<ActivitiesData>(ActivitiesStatusEnum.GET_ACTIVITIES_ORDER, {
        params,
      })
    );
    return { ...data, data: parseData(data.data) };
  },
});

const cancelActivityData = (api: AxiosInstance) => ({
  cancelActivity: async (id: string): Promise<any> => {
    const { data } = await handleErrorIntoService(
      api.post(`activity/order/${id}/cancel`)
    );
    return { ...data };
  },
});

export const hideOrder = (api: AxiosInstance) => ({
  hide: async (id: string | number) => {
    const { data } = await handleErrorIntoService(
      api.post(`${ActivitiesStatusEnum.PATCH_HIDE_ORDER}/${id}`)
    );
    return { ...data };
  },
});

export const activitiesService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getActivitiesData(api),
    ...getActivitiesOrderData(api),
    ...cancelActivityData(api),
    ...hideOrder(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/activities/activitiesService.ts